import { PropsWithChildren } from "react";

type LabeledTextProps = {
    label: string | React.ReactNode | React.ReactFragment;
    labelClassName?: string;
    className?: string;
    childClassName?: string;
    inline?: boolean;
};

export const LabeledText: React.FC<PropsWithChildren<LabeledTextProps>> = ({ label, children, labelClassName, className, childClassName, inline = false }) => {
    if (inline) {
        return (
            <div className={"flex items-center gap-2 " + (className || "")}>
                <label className={labelClassName ?? "text-sm text-muted-body-text"}>
                    {label}:
                </label>
                <div className={childClassName ?? ""}>
                    {children}
                </div>
            </div>
        );
    }
    return (
        <div className={"flex-row " + className}>
            <label className={labelClassName ?? " text-sm text-muted-body-text "}>{label}:</label>
            <div className={childClassName ?? "pl-2 py-2"}>
                {children}
            </div>
        </div>
    );

}